import { $Qll, $Q } from '../utils/query-selector';
import { dataToggle } from '../utils/toggle-dataset';
import { setSidebarMenuPosition } from '../utils/menu';
import { setOverflow } from '../utils/set-overflow';

function pushDataLayer(payload) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
}

function getMenuPath(node) {
  const explicit = (node.getAttribute('data-menu-path') || '').trim();
  if (explicit) return explicit;

  const parts = [];
  let current = node;

  while (current) {
    const item = (current.getAttribute('data-menu-item') || '').trim();
    if (item && parts[0] !== item) {
      parts.unshift(item);
    }

    const parent = current.parentElement;
    if (!parent) break;
    current = parent.closest('[data-menu-item]');
  }

  return parts.join(' > ');
}

function getMenuPayload(el) {
  if (!el) return null;

  const node = el.closest('[data-menu-item]');
  if (!node) return null;

  const menu_item = (node.getAttribute('data-menu-item') || '').trim();
  if (!menu_item) return null;

  const menu_path = getMenuPath(node);

  return {
    menu_item,
    menu_level: Number(node.getAttribute('data-menu-level')) || menu_path.split(' > ').filter(Boolean).length || 1,
    menu_path
  };
}

function isRealNavUrl(href) {
  if (!href) return false;

  const value = href.trim().toLowerCase();
  return value !== '' && value !== '#' && !value.startsWith('javascript:');
}

function pushMenuEvent(eventName, payload, extra = {}) {
  if (!payload) return;

  pushDataLayer({
    event: eventName,
    menu_item: payload.menu_item,
    menu_level: payload.menu_level,
    menu_path: payload.menu_path,
    ...extra
  });
}

function trackMenuEntry(el) {
  pushMenuEvent('menu_entry', getMenuPayload(el));
}

function isDesktopNav() {
  return window.matchMedia('(min-width: 1024px)').matches;
}

/**
 * add event listener to each arrow button in menu items
 */
function btnSubMenu() {
  $Qll('header .site-nav__item').forEach((item) => {
    const closestNavItem = item;
    const header = $Q('.header');

    if (!item || !header) return;

    item.addEventListener('mouseenter', () => showItemSubMenu(closestNavItem));
    header.addEventListener('mouseleave', () =>
      removeMenuActives(closestNavItem)
    );
  });

  $Qll('.sidebar-menu .site-nav__item').forEach((item) => {
    item.addEventListener('click', () => showItemSubMenu(item));
  });
}

/**
 *
 * @param {DOM element} item to toggle data-active
 * it will remove data-active from all other items and set data-active to item received
 */
function showItemSubMenu(item) {
  if (!item) return;

  const wasActive = item.getAttribute('data-active') === 'true';
  removeMenuActives(item);
  dataToggle(item);

  if (!wasActive && item.getAttribute('data-active') === 'true') {
    trackMenuEntry(item);
  }
}

function removeMenuActives(item) {
  const navItems = $Qll('.site-nav__item');

  if (!navItems) return;

  navItems.forEach((navItem) => {
    if (item !== navItem) navItem.setAttribute('data-active', 'false');
  });
}

function onClickButtonMenu() {
  const sidebarMenu = $Q('.sidebar-menu');
  const menuButton = $Q('.menu-button');

  if (!menuButton) return;

  const header = $Q('.jc-header');

  menuButton.addEventListener('click', () => {
    dataToggle(sidebarMenu);
    dataToggle(menuButton);

    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(header.getBoundingClientRect().bottom)}px`
    );

    const isActive = JSON.parse(sidebarMenu.dataset.active);
    if (isActive) {
      pushDataLayer({
        event: 'menu_open'
      });
      setOverflow('hidden', 'body');
    } else {
      setOverflow('auto', 'body');
    }
  });
}

/**
 * add event listener to close button in sidebar menu
 * it will close sidebar menu
 * CURRENTLY NOT IN USE
 */
function onClickCloseMenu() {
  const closeButton = $Q('.sidebar-menu__close');
  const sidebarMenu = $Q('.sidebar-menu');
  const menuButton = $Q('.menu-button');
  const shadowClose = $Q('.sidebar-menu-shadow');

  if (shadowClose) {
    shadowClose.addEventListener('click', () => {
      menuButton.click();
    });
  }

  if (!closeButton || !sidebarMenu) return;

  closeButton.addEventListener('click', () => {
    dataToggle(sidebarMenu);
  });
}

function onMenuLinkClick() {
  const header = $Q('.js-header');
  if (!header) return;

  header.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-menu-item]');
    if (!link || !header.contains(link)) return;

    const payload = getMenuPayload(link);
    if (!payload) return;

    pushMenuEvent('menu_entry', payload);

    if (isRealNavUrl(link.getAttribute('href'))) {
      pushMenuEvent('menu_click', payload, { menu_url: link.href });
    }
  });
}

function onDesktopMenuEntry() {
  $Qll('.js-header [data-menu-entry]').forEach((item) => {
    item.addEventListener('mouseenter', () => {
      if (!isDesktopNav()) return;
      trackMenuEntry(item);
    });
  });
}

function onMobileAccordionEntry() {
  $Qll('.js-header [data-menu-entry] input[type="checkbox"], .js-header [data-menu-entry] input[type="radio"]').forEach(
    (input) => {
      input.addEventListener('change', () => {
        if (!input.checked) return;
        trackMenuEntry(input);
      });
    }
  );
}

function onMobileSubmenuToggle() {
  $Qll('.js-header .jc-submenu-toggle').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      if (toggle.getAttribute('data-active') !== 'true') return;
      trackMenuEntry(toggle);
    });
  });
}

setSidebarMenuPosition();
btnSubMenu();
onClickButtonMenu();
onClickCloseMenu();
onMenuLinkClick();
onDesktopMenuEntry();
onMobileAccordionEntry();
onMobileSubmenuToggle();
